var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings settings--vessel-access-control pt-5",class:_vm.themeClass},[_c('DataTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }